export default "__VITE_ASSET__6R3fK2XF__"